<template>
  <section class='hero'>
    <div id='widget-container'>
      <div class="hero-head">
        <Banner v-show="getCurrentPage == 0 && !hideBanner"/>
      </div>
      <div class="hero-body">
        <navigation v-show="getCurrentPage != 1"></navigation>
        <slot />
      </div>
      <div class="hero-foot">
        <Footer />
      </div>
    </div>
    <b-modal :active="emailReportModalActive" :width="640" scroll="keep" :component="EmailForm" :onCancel="() => this.setEmailReportModalActive(false)">
    </b-modal>
    <b-modal :active="getMoreTeaserModalActive" :width="400" scroll="keep" :component="GetMoreTeaserForm" :onCancel="() => this.setGetMoreTeaserModalActive(false)">
    </b-modal>
  </section>
</template>

<script>
import Banner from '@/components/Banner'
import Footer from '@/components/Footer'
import Navigation from '@/components/Navigation'
import EmailForm from '@/components/EmailForm'
import GetMoreTeaserForm from '@/components/GetMoreEmailTeaserForm'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      EmailForm,
      GetMoreTeaserForm
    }
  },
  components: {
    Banner,
    Footer,
    Navigation,
    EmailForm,
    GetMoreTeaserForm
  },
  props: {
  },
  computed: {
    ...mapGetters([
      'getImageUrl',
      'getCurrentPage'
    ]),
    ...mapState([
      'emailReportModalActive',
      'getMoreTeaserModalActive',
      'hideBanner'
    ])
  },
  methods: {
    ...mapActions({
      setEmailReportModalActive: 'setEmailReportModalActive',
      setGetMoreTeaserModalActive: 'setGetMoreTeaserModalActive'
    })
  },
  mounted () {
  }
}
</script>

<style scoped>
.hero-body {
  padding: 1rem 1.5rem 3rem 0rem;
}

</style>
